export function checkOddAndFixed(value) {
    // Check if the value is odd
    const isOdd = value % 2 !== 0;
  
    // If the value is odd and non-zero, use toFixed
    if (isOdd && value !== 0) {
      return value.toFixed(2); 
    }
  
    // Return the original value if it is not odd or if it is zero
    return Number(value);
}